import { MdEdit, MdDelete } from "react-icons/md";

export default function ImagePreviewActions({ onEdit, onDelete }) {
  return (
    <div className="absolute inset-0 flex items-center justify-center gap-3 bg-gradient-to-t from-slate-950/60 via-slate-950/20 to-transparent opacity-100 transition-opacity duration-200 md:opacity-0 md:group-hover:opacity-100 md:group-focus-within:opacity-100 [@media(hover:none)]:opacity-100">
      <button
        type="button"
        onClick={onEdit}
        aria-label="Edit image"
        title="Edit image"
        className="flex h-11 w-11 items-center justify-center rounded-full border border-white/70 bg-white/95 text-blue-700 shadow-lg backdrop-blur-sm transition duration-200 hover:-translate-y-0.5 hover:bg-blue-50 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-blue-600 motion-reduce:transform-none"
      >
        <MdEdit size={21} aria-hidden="true" />
      </button>
      <button
        type="button"
        onClick={onDelete}
        aria-label="Delete image"
        title="Delete image"
        className="flex h-11 w-11 items-center justify-center rounded-full border border-white/30 bg-red-600/95 text-white shadow-lg backdrop-blur-sm transition duration-200 hover:-translate-y-0.5 hover:bg-red-700 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-red-600 motion-reduce:transform-none"
      >
        <MdDelete size={21} aria-hidden="true" />
      </button>
    </div>
  );
}
